/*
 * @Author: bbqin
 * @Date: 2022-10-26 10:41:48
 * @LastEditTime: 2023-10-12 15:25:19
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\sideBox.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { Sidebox as SideBox, Button, ButtonGroup, Tooltip, HotKeys } from '@platform/base';
import { promptBox } from '../PromptBox/index';
function sideBox(Container) {
    return class HOC extends Component {
        constructor(props) {
            super(props);
        }

        onSave = () => {
            const { store, onSave } = this.props;
            const newData = store.getTransformCache();
            // 更新对应的组件
            onSave && onSave(newData);
        };

        onHide = () => {
            const { store, onHide } = this.props;
            onHide && onHide();
        };

        onReset = () => {
            const { store, onReset } = this.props;
            const langJson = store.getStore('langJson') || {};

            promptBox({
                title: langJson['button-reset'] || '重置字段',
                color: 'warning',
                content: langJson['reset-confirm'],
                id: 'metaSettingReset',
                zIndex: 350,
                beSureBtnClick: () => {
                    onReset && onReset();
                },
                cancelBtnClick: () => {
                },
            });
        };

        renderTitle = () => {
            const { id, store, sideBox = {}, ...others } = this.props;
            const langJson = store.getStore('langJson') || {};
            const hc4 = (langJson['help-content-4'] || '').split('${')[0] || '';
            const tip = (
                <div className="col-setting-tips-overlay">
                    <p>{langJson['help-content-1']}：</p>
                    <p>1. {langJson['help-content-2'] + '：' + hc4}
                        <i className='iconfont icon-ncc-sq' />{langJson['help-content-5']}<i className='iconfont icon-shanchu4' />, {langJson['help-content-6']};
                    </p>
                    <p>2. {langJson['help-content-7'] + '：' + langJson['help-content-8']}；</p>
                    <p>3. {langJson['help-content-9']}：{langJson['help-content-3']}<i className='iconfont icon-weisuoding' />{langJson['help-content-10']}，{langJson['help-content-11']}；</p>
                    <p>4. {langJson['help-content-12']}：{langJson['help-content-13']}。</p>
                </div>
            );

            return <div className="setting-panel-header">
                <HotKeys
                    keyMap={{
                        sureBtnHandler:
                            HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                        cancelBtnHandler:
                            HotKeys.USUAL_KEYS.MODAL_CANCEL,
                    }}
                    handlers={{
                        sureBtnHandler: () => {
                            const promptBox = document.querySelector('.prompt-box.disabled-bg-btn');
                            if (promptBox) {
                                return;
                            }
                            // 确定按钮的事件 
                            console.log('sureBtnHandler 事件回调');
                            this.onSave();
                        },
                        cancelBtnHandler: () => {
                            const promptBox = document.querySelector('.prompt-box.disabled-bg-btn');
                            if (promptBox) {
                                return;
                            }
                            // 重置字段按钮的事件 
                            console.log('cancelBtnHandler 事件回调');
                            this.onHide();
                        },
                    }}
                    className="setting-panel-hotkeys-wrapper"
                    focused={true}
                    attach={document.body}
                    display="inline"
                />
                <div className="setting-panel-title">
                    {langJson['panel-header-title'] || '字段设置'}

                    <Tooltip
                        placement="rightTop"
                        className='col-setting-tips'
                        overlay={tip}
                    >
                        <span className="setting-help-icon">
                            <i className='iconfont icon-shuoming1' />
                            <i className='iconfont icon-shuoming2' />
                        </span>
                    </Tooltip >
                </div>
                <div className="setting-panel-btn-wrapper">
                    <ButtonGroup>
                        <Tooltip
                            placement="top"
                            inverse
                            overlay={`${langJson['button-save'] || '保存'} (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                            trigger={['hover', 'focus']}
                            className="model-helper-overlay"
                        >
                            <Button type="primary" colors="primary" onClick={this.onSave}>
                                {langJson['button-save'] || '保存'}(<span className="text-decoration-underline">Y</span>)
                            </Button>
                        </Tooltip>
                        <Button onClick={this.onReset}>{langJson['button-reset'] || '重置字段'}</Button>
                    </ButtonGroup>
                    <Tooltip
                        placement="top"
                        inverse
                        overlay={`${langJson['button-cancel'] || '取消'} (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                        trigger={['focus', 'hover']}
                        className="model-helper-overlay"
                    >
                        <Button onClick={this.onHide}>{langJson['button-cancel'] || '取消'}(<span className="text-decoration-underline">N</span>) </Button>
                    </Tooltip>
                </div>
            </div>;
        }

        render() {
            const { id, store, sideBox = {}, ...others } = this.props;
            const show = store.getStore(['config', 'visible']);

            return <SideBox
                title={this.renderTitle()}
                show={show}
                mask={true}
                maskClose={this.onHide}
                keyboard={true}
                width={800}
                onClose={this.onHide}
                className="field-setting-panel"
                showButton={false}
                {...sideBox}
            >
                <Container id={id} store={store} {...others} />
            </SideBox>;
        }
    };
}

export default sideBox;